import React, { Component } from 'react'
import { connect } from 'react-redux'
import { fetchVehicle } from './vehiclesActions'
import { selectVehicle } from '../../reducers/vehicles'
import VehicleDetailFormSanitizer from '../common/vehicles/vehicleDetailFormSanitizer'
import { updateVehicle } from '../refiApp/refiActions'
import LoaderButton from '../../components/loaderButton'
import { Vehicle } from '../../core/types'

const controls = (submitting, id) => (
  <div className="form__group">
    <LoaderButton
      type="submit"
      className="button button--primary button--inline"
      isLoading={submitting}
    >
      Save Changes
    </LoaderButton>
    <a
      href={`/vehicles/${id}`}
      className="button button--secondary"
      aria-label="cancel"
    >
      Cancel
    </a>
  </div>
)

export type Callback<T = void> = (...args: any) => T
export interface Match<T> {
  params: T
}

export interface ParamsID {
  id: string
}

export interface Props {
  fetchVehicle: Callback
  match: Match<ParamsID>
  vehicle: Vehicle
}

export class VehicleEdit extends Component<Props> {
  componentWillMount() {
    const { fetchVehicle, match, vehicle } = this.props
    if (!vehicle.id) {
      fetchVehicle(match.params.id)
    }
  }

  render() {
    const { vehicle } = this.props
    const { year, make, model, id } = vehicle

    return (
      <div className="vehicle-details--edit">
        <div className="vehicle-details__title">
          <h2>{`${year} ${make} ${model}`}</h2>
          <h4>{`Vehicle ID: ${id}`}</h4>
        </div>
        {vehicle.id && (
          <VehicleDetailFormSanitizer
            vehicle={vehicle}
            controls={controls}
            returnUrl={`/vehicles/${id}`}
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = (state, { match }) => ({
  vehicle: selectVehicle(state.vehicles, match.params.id),
})

export default connect(mapStateToProps, {
  fetchVehicle,
  updateVehicle,
})(VehicleEdit)
